import { memo } from "react";
import { getInitials } from "../../../../utils";
import { Avatar, message } from "antd";
import { useSelector } from "react-redux";
import { AlbanianFlagIcon, KosovoFlagIcon } from "../../../../assets/icons";
import { useNavigate } from "react-router";

const ChartCard = ({ src, employee, setOpen, navigateOnClick = true }) => {
  const navigate = useNavigate();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const fullName =
    employee?.employeeFirstName + " " + employee?.employeeLastName;
  const initials = getInitials(fullName);

  const handleClick = (id) => {
    if (!navigateOnClick) return;
    if (!id) {
      message.error("Punonjësi nuk u gjet!");
      return;
    }
    setOpen(false);
    navigate(`/punonjesit/specifikat/${id}`);
  };

  const flag = {
    "Flex Tirana": <AlbanianFlagIcon />,
    "Flex Prishtina": <KosovoFlagIcon />,
  };

  const { employeeStatus, employeeTeam } = employee || {};

  return (
    <div
      className="chartCard"
      onClick={() => handleClick(employee?.employeeId)}
    >
      <Avatar
        shape="circle"
        className={`${isDarkMode ? "dark" : ""}`}
        src={!!src ? <img src={src} /> : initials}
      >
        {initials}
      </Avatar>
      <div className="cardDetails">
        <span className="title">
          {fullName.length > 15 ? fullName.slice(0, 15) + "..." : fullName}
          {flag[employeeTeam]}
        </span>
        {!!employeeStatus ? <span>{employeeStatus}</span> : null}
      </div>
    </div>
  );
};

export default memo(ChartCard);
